

































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { institutionServer, performanceServer } from '@/api/installServer';
import ChoosePeople from '@/views/inspectionContents/checklist/unit/choosePeople.vue';
import { arrayToTree } from '@/util/array';

@Component({
  components: { ChoosePeople },
  mixins: [TableStripe],
})
export default class ViewItSonDialog extends Vue {
  private visible = false;
  private formData: any = {
    rectifyExpiryDate: '',
    reviewExpiryDate: '',
    rectifyChargeStaffId: '',
    rectifyChargeDeptId: '',
    supervisionUnitOpinion: '',
  };
  private subSpaceByAuthOptions: any = [];

  private rectifyChargeStaffName: any = '';
  private tableData: any = [];
  private hazardArr: any = [];
  private formRules: any = {
    rectifyExpiryDate: [{ required: true, message: '请选择整改截止日期', trigger: 'blur' }],
    reviewExpiryDate: [{ required: true, message: '请选择复查截止日期', trigger: 'blur' }],
    rectifyChargeStaffId: [{ required: true, message: '请选择人员', trigger: 'blur' }],
    rectifyChargeDeptId: [{ required: true, message: '请选择整改企业', trigger: 'blur' }],
  };

  // todo 进入弹窗的页面的时候走外层的表格的一行的id（详情接口） ---> hazards[]下面的rectifyFormId的没有数据的
  private showDialog(taskId: any) {
    /*const rectifyChargeDeptId: any = window.localStorage.getItem('rectifyChargeDeptId');
      if (rectifyChargeDeptId) {
        this.formData.rectifyChargeDeptId = rectifyChargeDeptId;
      } else {
        this.formData.rectifyChargeDeptId = '';
      }*/
    this.getTemplateDetailData(taskId);
    this.getSubSpaceByAuthData();
    this.formData.taskId = taskId;
    this.visible = true;
  }

  getSubSpaceByAuthData() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 检查单详情的接口（获取隐患列表）
  private getTemplateDetailData(id: any) {
    performanceServer.getTemplateDetail(id).then((res: any) => {
      if (res.code === '200') {
        this.tableData = res.data.hazards.filter((item: any) => !item.rectifyFormId);
      } else {
        this.$message.warning(res.mag);
      }
    });
  }

  private close() {
    // window.localStorage.setItem('rectifyChargeDeptId', this.formData.rectifyChargeDeptId);
    this.visible = false;
    this.formData = {
      rectifyExpiryDate: '',
      reviewExpiryDate: '',
      rectifyChargeStaffId: '',
      rectifyChargeDeptId: '',
      supervisionUnitOpinion: '',
    };
    this.rectifyChargeStaffName = '';
    this.$emit('rectifyFormRes');
  }

  // 创建表单
  private createSon() {
    const formComponent: any = this.$refs['formData'];
    formComponent.validate((valid: any) => {
      if (valid) {
        if (!this.hazardArr.length) {
          this.$message.warning('请选择隐患');
          return;
        }
        this.formData.hazardIds = this.hazardArr.map((item: any) => item.id);
        performanceServer.createForm({ ...this.formData }).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('创建成功！');
            this.close();
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        return;
      }
    });
  }

  private selectionChange(val: any) {
    if (val) {
      this.hazardArr = val;
    }
  }

  /**
   * @desc 人员
   * */
  checkNodeData1(data: any) {
    if (data && data.length) {
      this.formData.rectifyChargeStaffId = data[0].id;
      this.rectifyChargeStaffName = data[0].name;
    } else {
      this.formData.rectifyChargeStaffId = '';
      this.rectifyChargeStaffName = '';
    }
  }

  /**
   * @desc 参与人员
   * */
  choseSponsor1() {
    let chooseStaffArr: any = [];
    if (this.formData.rectifyChargeStaffId) {
      chooseStaffArr = [{ id: this.formData.rectifyChargeStaffId, name: this.rectifyChargeStaffName }];
    } else {
      chooseStaffArr = [];
    }
    (this.$refs['shuttleBox1'] as any).showDialog(chooseStaffArr, 'single');
  }
}
